import React from 'react';
import { Avatar, Box } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import { resolveUserAvatarUrl } from '../../../constants/userAvatars';
import { TEAM_CHAT_THEME, teamChatPresenceDotSx } from '../teamChatTheme';
import { initialsOf } from '../teamChatUtils';

interface TeamChatAvatarProps {
  name?: string | null;
  avatarUrl?: string | null;
  gender?: string | null;
  size?: number;
  /** `undefined` esconde o indicador (grupos, mensagens do sistema). */
  online?: boolean;
  isGroup?: boolean;
}

const TeamChatAvatar: React.FC<TeamChatAvatarProps> = ({
  name,
  avatarUrl,
  gender,
  size = 44,
  online,
  isGroup = false,
}) => {
  const resolved = isGroup ? avatarUrl || undefined : resolveUserAvatarUrl({ avatar_url: avatarUrl, gender });

  return (
    <Box sx={{ position: 'relative', flexShrink: 0, width: size, height: size }}>
      <Avatar
        src={resolved}
        alt={name || undefined}
        sx={{
          width: size,
          height: size,
          fontSize: size * 0.36,
          fontWeight: 700,
          bgcolor: isGroup ? TEAM_CHAT_THEME.tealSoft : TEAM_CHAT_THEME.primarySoft,
          color: isGroup ? TEAM_CHAT_THEME.tealDark : TEAM_CHAT_THEME.primary,
          border: `1px solid ${TEAM_CHAT_THEME.borderSoft}`,
        }}
      >
        {isGroup ? <GroupsIcon sx={{ fontSize: size * 0.5 }} /> : initialsOf(name)}
      </Avatar>
      {online !== undefined && (
        <Box
          sx={{
            ...teamChatPresenceDotSx(online),
            position: 'absolute',
            bottom: 0,
            right: 0,
          }}
        />
      )}
    </Box>
  );
};

export default TeamChatAvatar;
